import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from './styles';
import api from '../../../services/api';

 interface IProcedureProperties {
  proced_id: number | null;
  proced_descricao: string;
}

const Procedure: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyProcedure = {
    proced_id: null,
    proced_descricao: '',
  };

  const [procedures, setProcedures] = useState<IProcedureProperties[]>([]);
  const [procedure, setProcedure] = useState(emptyProcedure);
  const [deleteProcedure, setDeleteProcedureDialog] = useState(false);
  const [deleteProceduresDialog, setDeleteProceduresDialog] = useState(false);
  const [selectedProcedures, setSelectedProcedures] = useState<IProcedureProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await api.get('/lawsuits/procedures/show/all');
      setProcedures(response.data);
    })();
  }, []);

  const columns = [
    { field: 'proced_id', header: 'Código', sortable: true },
    { field: 'proced_descricao', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/lawsuit/procedure/create');
  };

  const hidedeleteProcedure = () => {
    setDeleteProcedureDialog(false);
  };

  const hidedeleteProceduresDialog = () => {
    setDeleteProceduresDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editProcedure = (rowData:any) => {
    history.push(`/lawsuit/procedure/edit/${rowData.proced_id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteProcedure = (procedure: React.SetStateAction<{
    proced_id: null; proced_descricao: string;
  }>) => {
    setProcedure(procedure);
    setDeleteProcedureDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/procedures/delete/${procedure.proced_id}`);

    setDeleteProcedureDialog(false);

    const updatedRecords = procedures
      .filter((val) => val.proced_id !== procedure.proced_id);
    setProcedures(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      <Button
        type="button"
        icon="pi pi-pencil"
        tooltip="Alterar cadastro"
        tooltipOptions={{ position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain p-mr-2"
        onClick={() => { editProcedure(rowData); }}
      />
      <Button
        type="button"
        icon="pi pi-trash"
        tooltip="Excluir cadastro"
        tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => { confirmDeleteProcedure(rowData); }}
      />
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteProcedureFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteProcedure} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );
  const deleteProceduresDialogFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteProceduresDialog} />
      {/* <Button label="Sim" icon="pi pi-check" className="p-button-text"
      onClick={deleteselectedProcedures} /> */}
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Procedimentos</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-procedures table"
            id="table-procedures"
            ref={dt}
            value={procedures}
            editMode="row"
            dataKey="proced_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedProcedures}
            onSelectionChange={(e) => {
              const selProcedures = e.value as IProcedureProperties[];
              setSelectedProcedures(selProcedures);
            }}
            onRowDoubleClick={(e) => editProcedure(e.data)}
          >
            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} /> */}
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteProcedure} style={{ width: '450px' }} header="Confirmação" modal footer={deleteProcedureFooter} onHide={hidedeleteProcedure}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {procedure && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{procedure.proced_descricao}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>

          <Dialog visible={deleteProceduresDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteProceduresDialogFooter} onHide={hidedeleteProceduresDialog}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {procedure
              && <span>Você tem certeza que deseja excluir os cadastros selecionados?</span>}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default Procedure;
